import React from "react";

const Loading = ({ dark }) => {
    return (
        <>
            <div className="loading-dots">
                <div className={`dot ${dark ? "dark-dot" : ""}`}></div>
                <div className={`dot ${dark ? "dark-dot" : ""}`}></div>
                <div className={`dot ${dark ? "dark-dot" : ""}`}></div>
            </div>
        </>
    );
}

export default Loading;